import { render, staticRenderFns } from "./vue-extend-layout.vue?vue&type=template&id=4629a332&"
import script from "./vue-extend-layout.vue?vue&type=script&lang=js&"
export * from "./vue-extend-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports